<template>
  <div class="how-it-works bg--color-11">
    <div class="container-wrapper bg--color-01">
      <div class="how-it-works__container container-new">
        <h4
          class="how-it-works__title txt--bold txt--36px txt--44px--l txt--height-44px txt--height-58px--l txt--color-04 mb-24 mb-60--l"
        >
          {{ $t('cryptoCampus.howItWorks.title') }}
        </h4>
        <div class="how-it-works__items">
          <div
            v-for="(item, indx) in items"
            :key="items[item]"
            class="how-it-works__item"
          >
            <div class="how-it-works__item-id" :class="item.idBackground">
              <span> 0{{ ++indx }} </span>
            </div>
            <p
              class="txt--bold txt--16px txt--26px--l txt--height-20px txt--height-34px--l txt--color-04 mb-0"
            >
              {{ item.text }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HowItWorks',
  components: {},
  computed: {
    items () {
      return [
        {
          idBackground: 'bg--color-09',
          text: this.$t('cryptoCampus.howItWorks.list[0]'),
        },
        {
          idBackground: 'bg--color-10',
          text: this.$t('cryptoCampus.howItWorks.list[1]'),
        },
        {
          idBackground: 'bg--color-06',
          text: this.$t('cryptoCampus.howItWorks.list[2]'),
        },
        {
          idBackground: 'bg--color-11',
          text: this.$t('cryptoCampus.howItWorks.list[3]'),
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.how-it-works {
  &__title {
    @include bp(l) {
      text-align: center;
    }
  }

  &__items {
    width: 100%;
    display: grid;
    gap: toRem(16px);

    @include bp(m) {
      grid-template-columns: repeat(2, 1fr);
    }

    @include bp(l) {
      gap: toRem(24px);
    }
  }

  &__item {
    border-radius: toRem(20px);
    padding: toRem(16px);
    display: flex;
    align-items: center;
    gap: toRem(12px);
    background: color('color-02');

    @include bp(l) {
      gap: toRem(34px);
    }
  }

  &__item-id {
    border-radius: toRem(8px);
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: toRem(56px);
    min-height: toRem(56px);

    span {
      font-weight: 400;
      font-size: toRem(40px);
      line-height: toRem(34px);
      color: color('color-04');
    }

    @include bp(l) {
      border-radius: toRem(10px);
      min-width: toRem(120px);
      min-height: toRem(108px);

      span {
        font-size: toRem(72px);
        line-height: toRem(34px);
      }
    }
  }
}
</style>
